import React from 'react';
import { InHomeUtils } from './../util/inhomeUtils';

export default class proactiveContent extends React.PureComponent {  
  render() {

    let deviceType = "mobile";
    const  iconclass = InHomeUtils.getdeviceType() === deviceType ? "Icon Icon--tag text-large vert-middle hide" : "Icon Icon--tag text-large vert-middle"; 

    return (
      <div className="w_ltd-offer">
        <div className="ltd-offer-tile">
          <div className="ltd-offer-details">
            <span className={iconclass} aria-hidden="true"></span>
            <div className="inline-block medium-p-auto padding-left-micro vert-middle ">
              <span>{this.props.proactiveText}</span>                           
            </div>
          </div>
        </div>
      </div>
    );
  }
}